
import Vue from "vue";
import AppCustomTable from "@/components/common/CustomTable.vue";
import { ToolbarService } from "@/services/toolbar-service";
import { checkHasModule } from "@/router";
import { MODULE } from "@/config/modules";
import { FixedAsset } from "@/models/base/fixed-asset";
import { FixedAssetService, IInvestmentPurchase } from "@/services/fixed-asset-service";
import { BookYearService } from "@/services";
import { printHumanFloat, printLocalDate } from "@/utils/pretty-print";

export default Vue.extend({
	data() {
		return {
			assets: [] as FixedAsset[],
			missingPurchases: [] as IInvestmentPurchase[],
			loaded: false,
			isBooking: false
		};
	},
	computed: {
		bookYear():number {
			return BookYearService.selectedBookYear;
		},
		activeAssets():FixedAsset[] {
			return this.assets.filter(a => !a.DisposedAt);
		},
		disposedAssets():FixedAsset[] {
			return this.assets.filter(a => a.DisposedAt);
		},
		activeAcquisitionTotal():number {
			return this.activeAssets.reduce((sum, a) => sum + (a.AcquisitionValue || 0), 0);
		}
	},
	methods: {
		printHumanFloat,
		printLocalDate,
		statusClass(asset:FixedAsset):string {
			if (asset.DisposedAt) return "fa-chip-disposed";
			if (asset.Years <= 0) return "fa-chip-neutral";
			return "fa-chip-active";
		},
		statusLabel(asset:FixedAsset):string {
			if (asset.DisposedAt) return this.$ct("status-disposed", {date: printLocalDate(asset.DisposedAt)}).toString();
			if (asset.Years <= 0) return this.$ct("status-not-depreciable").toString();
			return this.$ct("status-active").toString();
		},
		async refresh() {
			this.assets = await FixedAssetService.getAll();
			this.missingPurchases = await FixedAssetService.getInvestmentPurchases(true);
			this.loaded = true;
		},
		openAsset(asset:FixedAsset) {
			this.$router.push(`/fixed-assets/edit/${asset.ID}`);
		},
		createFromPurchase(item:IInvestmentPurchase) {
			this.$router.push({path: "/fixed-assets/new", query: {purchaseId: `${item.purchase.ID}`, bookYear: `${item.purchase.BookYear}`}});
		},
		async bookDepreciations() {
			this.isBooking = true;
			try {
				let result = await FixedAssetService.bookDepreciations(this.bookYear);
				this.$wf.notify(this.$ct("book-result", result).toString(), "success", 5000, "check");
			} finally {
				this.isBooking = false;
			}
		}
	},
	async mounted() {
		ToolbarService.title = this.$ct("title");
		await this.refresh();
	},
	created() {
		if (!checkHasModule(MODULE.AFSCHRIJVINGSTABELLEN, this.$router)) {
			throw new Error("MISSING MODULE");
		}
	},
	components: {
		AppCustomTable
	},
	i18nEx: {
		componentPrefix: "components.fixed-assets"
	}
});
